import { graphql } from 'gatsby'

// eslint-disable-next-line no-restricted-exports
export { default } from './Page'

export const query = graphql`
  query ($slug: String!) {
    ghostPage(slug: { eq: $slug }) {
      ...GhostPageFields
    }
  }
`
